import(/* webpackMode: "eager" */ "/vercel/path0/src/app/2257/page.tsx");
